import styled from 'styled-components';

import Input from '../../../../components/Inputs/Input';

import theme from '../../../../styles/defaultTheme';

export const Container = styled.div`
  width: 100%;
  padding: 0px 16px;
`;

export const ShowLength = styled.h1`
  font-size: ${theme.font.size15};
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin: 4px 4px 4px 0px;
  color: #5B5B5F;
  font: ${theme.font.body[2]};
  letter-spacing: 0px;
  color: ${(props) => props.theme.grey};
`;

export const AlertGroup = styled.div`
  padding: 0px 16px;
`;

export const ContainerContribution = styled.div`
  display: flex;
  gap: 10px;

  & > * {
    width: 111px;
  }

  @media screen and (max-width: 950px) {
      flex-direction: column;
      justify-content: center;

      & + div:nth-child(2) {
        padding-left: 10px;
      }

      & > * {
        width: 100%;
      }
  }
`;

export const SectionContribution = styled.div`
  width: 100%;
  
  > div:first-child {
    padding: 0px;
    margin: 0px 0px 8px;
  }

  > div:not(:first-child) {
    background-color:  ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderWhite};
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 16px 24px 0px 0px;
    :last-child {
      margin-bottom: 24px;
    }
  }
`;

export const CustomInput = styled(Input)`
    background-color: ${(props) => props.theme.disabledGrey10} !important;
    color: ${(props) => props.theme.grey} !important;
    border: 1px solid ${(props) => props.theme.lightGrey40};
    
    :hover {
      border: 1px solid ${(props) => props.theme.lightGrey40} !important;
    }
   
`;
